import { FormField, FormInput } from '@practium/ui';
import { isBrazilMapAvailable } from '../../utils/brazilMap';
import { pluralize } from '../../utils/format';
import { BrazilMapSVG } from '../Map/BrazilMap/BrazilMapSVG';
import styles from './MapRightPanel.module.css';

interface MapRightPanelProps {
	isSelectBase: boolean;
	regionName: string;
	selectedStateCodes: string[];
	unavailableStateCodes: string[];
	nameError?: string;
	statesError?: string;
	onNameChange: (name: string) => void;
	onToggleState: (code: string) => void;
}

export const MapRightPanel = ({
	isSelectBase,
	regionName,
	selectedStateCodes,
	unavailableStateCodes,
	nameError,
	statesError,
	onNameChange,
	onToggleState,
}: MapRightPanelProps) => {
	return (
		<div className={styles.panel}>
			{isSelectBase ? (
				<div className={styles.title}>Deseja usar alguma região como base?</div>
			) : (
				<FormField label="Nome da região" required error={nameError}>
					<FormInput
						value={regionName}
						placeholder="Ex.: Sudeste"
						hasError={!!nameError}
						onChange={(e) => onNameChange(e.target.value)}
					/>
				</FormField>
			)}

			{isBrazilMapAvailable ? (
				<div className={styles.mapContainer}>
					<BrazilMapSVG
						selectedStateCodes={isSelectBase ? [] : selectedStateCodes}
						disabledStateCodes={isSelectBase ? undefined : unavailableStateCodes}
						onToggleState={isSelectBase ? undefined : onToggleState}
					/>
				</div>
			) : (
				<div className={styles.statesContainer}>
					{selectedStateCodes.length === 0 || isSelectBase ? (
						<span className={styles.noStates}>
							{isSelectBase ? 'Selecione uma região à esquerda' : 'Nenhum estado selecionado'}
						</span>
					) : (
						<>
							<span className={styles.statesLabel}>{pluralize(selectedStateCodes.length, 'estado', 'estados')}</span>
							<div className={styles.statesGrid}>
								{selectedStateCodes.map((code) => (
									<span key={code} className={styles.stateChip}>
										{code}
									</span>
								))}
							</div>
						</>
					)}
				</div>
			)}

			{statesError && (
				<span className={styles.error} role="alert">
					{statesError}
				</span>
			)}
		</div>
	);
};
